import { render, staticRenderFns } from "./viewUploadCustom.vue?vue&type=template&id=1b9d7567"
import script from "./viewUploadCustom.vue?vue&type=script&lang=js"
export * from "./viewUploadCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9d7567')) {
      api.createRecord('1b9d7567', component.options)
    } else {
      api.reload('1b9d7567', component.options)
    }
    module.hot.accept("./viewUploadCustom.vue?vue&type=template&id=1b9d7567", function () {
      api.rerender('1b9d7567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsUploadCustom/viewUploadCustom.vue"
export default component.exports